import React from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import scrollToElement from 'scroll-to-element';

import SectionHeader from 'components/shared/landing/section-header';
import FormContact from 'components/form-contact';
import MainHeader, {
  HeaderText,
  Underline,
} from 'components/shared/landing/main-header';
import CustomVideo from 'components/shared/custom-video';
import styles from './styles.module.scss';

import learningCentersVideo from 'assets/videos/test-scores-video.mp4';
import learningCentersPoster from 'assets/img/test-scores-video-poster.jpg';
import playIcon from 'assets/img/video-play-button.svg';
import sparkDeeperLearningIcon from 'assets/img/landing/Illustration-3-Spark-Deeper-Learning.svg';
import communityIcon from 'assets/img/landing/landing-icon-community@2x.png';
import personalizeDevelopmentIcon from 'assets/img/landing/Illustration-5-Personilized-Customized-Development.svg';
import dataIcon from 'assets/img/landing/landing-icon-data-white.svg';
import studentCenteredIcon from 'assets/img/landing/Illustration-1-Student-Centered.svg';
import developWholeStudentIcon from 'assets/img/landing/Illustration-4-Develop-the-Whole-Student.svg';
import LuWorkshops from './images/lu-workshops.jpg';
import DevelopSEL from 'assets/img/developing-social-emotional-skills.jpg';

const Parent = () => (
  <div className={styles.parent}>
    <MainHeader
      header={
        <HeaderText className={styles.headerText}>
          Is <Underline>your&nbsp;child's&nbsp;potential</Underline>
          <br />
          being truly unlocked?
        </HeaderText>
      }
      subtext="Access the methods and skills needed for your child to thrive."
      onButtonClick={() => scrollToElement('#forward-thinking')}
      buttonText="Why Unyted"
      buttonClassName="apple"
      videoElement={
        <CustomVideo
          src={learningCentersVideo}
          poster={learningCentersPoster}
          icon={playIcon}
        />
      }
      videoElementContainerClassName={styles.video}
      flip
    />
    <section id="services" className={styles.learningCenters}>
      <div className="container">
        <div className="row mb-5">
          <div className="col">
            <SectionHeader
              tagline="cutting edge"
              valueprop="Out-of-School Services"
            />
          </div>
        </div>
        <div className="row">
          <div className={`col-12 col-lg-6 ${styles.inner}`}>
            <div className={styles.image}>
              <img src={DevelopSEL} alt="" />
            </div>
            <h2>Unyted Learning Centers</h2>
            <p>
              Connect your child with an elite educator who'll go beyond
              traditional tutoring for long-lasting results.
            </p>
            <Link to="/unyted-learning-centers">
              <button className={styles.ctaButton}>
                Find an Online Center
              </button>
            </Link>
          </div>
          <div className={`col-12 col-lg-6 ${styles.inner}`}>
            <div className={styles.image}>
              <img src={LuWorkshops} alt="" />
            </div>
            <h2>SEL Power Skills Workshops</h2>
            <p>
              Be clear on the SEL information & best practices to guarantee your
              child's optimal development.
            </p>
            <Link to="/workshops">
              <button className={styles.ctaButtonSecondary}>
                Find a Workshop
              </button>
            </Link>
          </div>
        </div>
      </div>
    </section>
    <section id="forward-thinking" className={styles.forwardThinking}>
      <div className="container">
        <div className="row">
          <div className="col">
            <SectionHeader
              tagline="forward-thinking"
              valueprop="Why Parents Choose Our Services"
              subtext="Parents requested a way to fill gaps created by their child's school."
            />
          </div>
        </div>
        <div className="row mt-5">
          <div className="col-12 col-md-6 col-lg-4">
            <div className={styles.reason}>
              <div className={classNames(styles.inner, styles.first)}>
                <div className={styles.icon}>
                  <img src={sparkDeeperLearningIcon} alt="" />
                </div>
                <p>
                  Get empowered with{' '}
                  <Link target="_blank" to="/workshops">
                    detailed SEL awareness
                  </Link>
                </p>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <div className={styles.reason}>
              <div className={classNames(styles.inner, styles.second)}>
                <div className={styles.icon}>
                  <img src={communityIcon} alt="" />
                </div>
                <p>Due to red tape, schools are too slow to adjust</p>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <div className={styles.reason}>
              <div className={classNames(styles.inner, styles.third)}>
                <div className={styles.icon}>
                  <img src={personalizeDevelopmentIcon} alt="" />
                </div>
                <p>Seek ability to customize your child's growth</p>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <div className={styles.reason}>
              <div className={classNames(styles.inner, styles.fourth)}>
                <div className={styles.icon}>
                  <img src={studentCenteredIcon} alt="" />
                </div>
                <p>Guarantee child's educator is student-centered</p>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <div className={styles.reason}>
              <div className={classNames(styles.inner, styles.fifth)}>
                <div className={styles.icon}>
                  <img src={developWholeStudentIcon} alt="" />
                </div>
                <p>Aim beyond good grades and develop "whole" child</p>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-4">
            <div className={styles.reason}>
              <div className={classNames(styles.inner, styles.sixth)}>
                <div className={styles.icon}>
                  <img src={dataIcon} alt="" />
                </div>
                <p>Use real-time data to back up your child's action plans</p>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <button onClick={() => scrollToElement('#services')}>
            Find a Service
          </button>
        </div>
      </div>
    </section>
    <section id="contact" className={styles.contact}>
      <div className="container">
        <div className="row">
          <div className="col">
            <FormContact
              showHeader
              showSubtext
              messageLabel="Do you have any questions or comments?"
              append="Type: Parent"
            />
          </div>
        </div>
      </div>
    </section>
  </div>
);

export default Parent;
